// FORGE Trailer — Szenen-Markup (gerendert in die Coming-Soon-Seite)
const SIGNET =
  '<svg class="tr-intro-o" viewBox="0 0 32 32" aria-hidden="true">' +
    '<defs><linearGradient id="tr-gio" x1="0" y1="1" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#C94D1A"/><stop offset=".5" stop-color="#E85D24"/><stop offset="1" stop-color="#F5A623"/>' +
    '</linearGradient></defs>' +
    '<circle cx="16" cy="16" r="9.5" fill="none" stroke="#E85D24" stroke-width="8" opacity=".2"/>' +
    '<circle cx="16" cy="16" r="9.5" fill="none" stroke="url(#tr-gio)" stroke-width="4.5" stroke-linecap="round" stroke-dasharray="50.3 9.4" transform="rotate(-79 16 16)"/>' +
    '<circle cx="23.1" cy="8.9" r="2.1" fill="#F5C623"/></svg>';

const AGENT_CHIPS = [
  ['OSCAR', '#3B6D11', 'OKR'], ['MAX', '#854F0B', 'Orchestrator'], ['VERA', '#1D9E75', 'Requirements'],
  ['STELLA', '#0C447C', 'User Stories'], ['TARA', '#042C53', 'Tests first'], ['DEV', '#185FA5', 'Code'],
  ['QUINN', '#0C447C', 'Review & QA'], ['MONA', '#712B13', 'Monitoring'], ['FINN', '#0C5E4A', 'Finance & ROI'],
  ['NOVA', '#3B6D40', 'Onboarding'], ['SCAN', '#6B3A2A', 'Security'], ['GARD', '#993556', 'DSGVO'], ['CLEO', '#7B1F3A', 'Executive'],
];

function sidebar(sc, active) {
  const items = [['◫', 'Dashboard'], ['↻', 'Feature Loops'], ['◎', 'OKRs'], ['⬡', 'Agenten']];
  return '<div class="p-side"><div class="p-logo">F<span>O</span>RGE</div><div class="p-sec">Portal</div>' +
    items.map((it, i) =>
      '<div class="p-item' + (i === active ? ' on' : '') + '">' + it[0] + ' ' + it[1] +
      (i === active && active === 1 ? ' <span class="p-badge">3</span>' : '') + '</div>').join('') +
    '</div>';
}

export function trailerHTML(tx) {
  const s = tx.scenes;
  const chips = AGENT_CHIPS.map((a, i) =>
    '<div class="tr-agent" data-step style="--i:' + (i + 1) + ';--dot:' + a[1] + '"><i></i>' + a[0] + ' <small>' + a[2] + '</small></div>').join('');

  return '<div class="cs-trailer" id="tr-section">' +
    '<div class="cs-slbl">' + tx.label + '</div>' +
    '<div class="tr-stage" id="tr-stage" tabindex="0">' +

    '<section class="tr-scene" data-dur="8" data-key="intro" data-fx="clang">' +
      '<div class="tr-intro-ring" data-step style="--i:0">' + SIGNET + '</div>' +
      '<div class="tr-intro-studio" data-step style="--i:1">FORGE-Factory</div>' +
      '<div class="tr-intro-sub" data-step style="--i:2">' + s.intro.sub + '</div>' +
    '</section>' +

    '<section class="tr-scene" data-dur="11" data-key="cold">' +
      '<div class="tr-eyebrow" data-step style="--i:0">' + s.cold.eyebrow + '</div>' +
      '<div class="tr-bigwords" style="--stagger:1.6s">' +
        '<div class="tr-bigword dim" data-step style="--i:1">' + s.cold.w1 + '</div>' +
        '<div class="tr-bigword dim" data-step style="--i:2">' + s.cold.w2 + '</div>' +
        '<div class="tr-bigword" data-step style="--i:3">' + s.cold.w3 + '</div>' +
      '</div><p class="tr-sub" data-step style="--i:4">' + s.cold.sub + '</p>' +
    '</section>' +

    '<section class="tr-scene" data-dur="9" data-key="frage">' +
      '<h3 class="tr-h1" style="--stagger:1.5s"><span data-step style="--i:0">' + s.frage.l1 + '</span><br>' +
      '<span data-step style="--i:1">' + s.frage.l2 + '</span><br>' +
      '<span data-step style="--i:2"><em>' + s.frage.l3 + '</em></span></h3>' +
    '</section>' +

    '<section class="tr-scene" data-dur="10" data-key="reveal">' +
      '<div class="tr-eyebrow" data-step style="--i:0">' + s.reveal.eyebrow + '</div>' +
      '<div class="tr-wordmark" data-step style="--i:1">F<span>O</span>RGE</div>' +
      '<h3 class="tr-h2" data-step style="--i:2">' + s.reveal.h + '</h3>' +
      '<p class="tr-sub" data-step style="--i:3">' + s.reveal.sub + '</p>' +
    '</section>' +

    '<section class="tr-scene" data-dur="10" data-key="team">' +
      '<h3 class="tr-h2" data-step style="--i:0">' + s.team.h + '</h3>' +
      '<div class="tr-agents" style="--stagger:.22s">' + chips +
        '<div class="tr-agent" data-step style="--i:14;--dot:#B0ADB8"><i></i>' + s.team.more + ' <small>' + s.team.moreSub + '</small></div>' +
      '</div>' +
    '</section>' +

    '<section class="tr-scene light" data-dur="15" data-key="loop">' +
      '<div class="tr-portal" data-step style="--i:0">' + sidebar(s, 1) +
        '<div class="p-main"><div class="p-top"><div class="p-title">' + s.loop.title + '</div></div><div class="p-body">' +
          '<div class="p-card"><div class="p-label">' + s.loop.card + '</div>' +
            '<div class="tr-typebox"><div class="tr-field"><span id="tr-typed"></span><span class="tr-caret"></span></div>' +
            '<div class="tr-btn">' + s.loop.btn + '</div></div></div>' +
          '<div class="tr-chain">' +
            ['MAX', 'STELLA', 'TARA', 'DEV', 'QUINN'].map((a, i) =>
              (i ? '<span class="tr-arrow">→</span>' : '') +
              '<div class="tr-chnode" style="--d:' + (2.6 + i * 1.4).toFixed(1) + 's"><i></i>' + a + '</div>').join('') +
          '</div>' +
          '<div class="tr-log" style="--stagger:1.3s">' +
            [['STELLA', s.loop.l1, 3], ['TARA', s.loop.l2, 4], ['DEV', s.loop.l3, 5], ['QUINN', s.loop.l4, 6]].map(r =>
              '<div class="tr-lrow" data-step style="--i:' + r[2] + '"><span class="tr-who">' + r[0] + '</span><span>' + r[1] + '</span></div>').join('') +
          '</div>' +
        '</div></div></div>' +
    '</section>' +

    '<section class="tr-scene light" data-dur="11" data-key="accept">' +
      '<div class="tr-portal" data-step style="--i:0">' + sidebar(s, 1) +
        '<div class="p-main"><div class="p-top"><div class="p-title">' + s.accept.title + '</div></div>' +
        '<div class="p-body" style="--stagger:.9s"><div class="p-card">' +
          '<div class="tr-srow"><div class="tr-stitle">' + s.accept.story + '</div><span class="tr-badge amber">' + s.accept.wait + '</span></div>' +
          '<div class="tr-badges"><span class="tr-badge green">' + s.accept.b1 + '</span><span class="tr-badge blue mono">FORGE-47</span><span class="tr-badge blue">' + s.accept.b3 + '</span></div>' +
          '<div class="tr-link hot" data-step style="--i:1"><span class="tr-lico">🚀</span><span><span class="tr-lsub">' + s.accept.pvSub + '</span><br><span class="tr-lmain">' + s.accept.pvMain + '</span></span><span class="tr-larr">↗</span></div>' +
          '<div class="tr-link" data-step style="--i:2"><span class="tr-lico">🔀</span><span><span class="tr-lsub">' + s.accept.prSub + '</span><br><span class="tr-lmain">PR #7 · <span class="mono">feature/forge-47</span></span></span><span class="tr-larr">↗</span></div>' +
          '<div class="tr-actions" data-step style="--i:3"><div class="tr-btn">' + s.accept.ok + '</div><div class="tr-btn ghost">' + s.accept.no + '</div></div>' +
        '</div></div></div></div>' +
    '</section>' +

    '<section class="tr-scene light" data-dur="10" data-key="okr">' +
      '<div class="tr-portal" data-step style="--i:0">' + sidebar(s, 0) +
        '<div class="p-main"><div class="p-top"><div class="p-title">' + s.okr.title + '</div></div><div class="p-body">' +
          '<div class="tr-kpis">' +
            [[s.okr.k1, 15, ' min', s.okr.k1s], [s.okr.k2, 94, ' %', s.okr.k2s], [s.okr.k3, 38, '', s.okr.k3s], [s.okr.k4, 100, ' %', s.okr.k4s]].map(k =>
              '<div class="tr-kpi"><div class="tr-klabel">' + k[0] + '</div><div class="tr-kval"><span class="tr-cnt" data-to="' + k[1] + '">0</span><small>' + k[2] + '</small></div><div class="tr-ksub">' + k[3] + '</div></div>').join('') +
          '</div>' +
          '<div class="p-card" style="margin-top:1.8cqh"><div class="p-label">' + s.okr.okr + '</div>' +
            [[s.okr.o1, 78, 1], [s.okr.o2, 62, 2], [s.okr.o3, 41, 3]].map(o =>
              '<div class="tr-orow" data-step style="--i:' + o[2] + '"><b>' + o[0] + '</b><div class="tr-obar"><div style="--w:' + o[1] + '%"></div></div><span class="tr-opct">' + o[1] + ' %</span></div>').join('') +
          '</div>' +
        '</div></div></div>' +
    '</section>' +

    '<section class="tr-scene" data-dur="11" data-key="duel">' +
      '<h3 class="tr-h2" data-step style="--i:0">' + s.duel.h + '</h3>' +
      '<div class="tr-duel" style="--stagger:.5s">' +
        '<div class="tr-dcol old" data-step style="--i:1"><div class="tr-dh">' + s.duel.old + '</div>' +
          [s.duel.o1, s.duel.o2, s.duel.o3, s.duel.o4, s.duel.o5].map((t, i) =>
            '<div class="tr-drow" data-step style="--i:' + (2 + i * 2) + '"><span class="tr-dico">✕</span><span>' + t + '</span></div>').join('') + '</div>' +
        '<div class="tr-dcol new" data-step style="--i:1"><div class="tr-dh">F<span>O</span>RGE</div>' +
          [s.duel.n1, s.duel.n2, s.duel.n3, s.duel.n4, s.duel.n5].map((t, i) =>
            '<div class="tr-drow" data-step style="--i:' + (3 + i * 2) + '"><span class="tr-dico">✓</span><span>' + t + '</span></div>').join('') + '</div>' +
      '</div>' +
    '</section>' +

    '<section class="tr-scene" data-dur="16" data-key="cta">' +
      '<div class="tr-launch" data-step style="--i:0">✦ <span>' + s.cta.badge + '</span> <b>' + s.cta.date + '</b></div>' +
      '<h3 class="tr-h2" data-step style="--i:1;margin-top:1.6cqh">' + s.cta.h + '</h3>' +
      '<div class="tr-stats" style="--stagger:.35s">' +
        [['27', s.cta.s1, 2], ['10<em>×</em>', s.cta.s2, 3], ['~15<em> min</em>', s.cta.s3, 4], ['100<em> %</em>', s.cta.s4, 5]].map(st =>
          '<div class="tr-stat" data-step style="--i:' + st[2] + '"><span class="tr-n">' + st[0] + '</span><span class="tr-l">' + st[1] + '</span></div>').join('') +
      '</div>' +
      '<button type="button" class="tr-cta-btn" data-step style="--i:6" onclick="document.getElementById(\'cs-email\')?.focus({preventScroll:false});document.querySelector(\'.cs-cta\')?.scrollIntoView({behavior:\'smooth\'})">' + s.cta.btn + '</button>' +
      '<p class="tr-cta-sub" data-step style="--i:7">' + s.cta.sub + '</p>' +
      '<div class="tr-cta-url" data-step style="--i:8">forge-factory.app</div>' +
    '</section>' +

    '<div class="tr-bar top"></div>' +
    '<div class="tr-bar bot"><div class="tr-subtitle" id="tr-subtitle"></div></div>' +
    '<div class="tr-overlay" id="tr-overlay">' +
      '<div class="tr-ov-mark">F<span>O</span>RGE</div>' +
      '<button class="tr-ov-play" id="tr-play" type="button">' + tx.play + '</button>' +
      '<div class="tr-ov-note">' + tx.note + '</div>' +
    '</div>' +

    '</div>' +
    '<div class="tr-player">' +
      '<button class="tr-pp" id="tr-pp" aria-label="Play/Pause" type="button">▶</button>' +
      '<button class="tr-mute" id="tr-mute" aria-label="Ton" type="button">🔊</button>' +
      '<div class="tr-segs" id="tr-segs" role="group"></div>' +
      '<div class="tr-meta"><strong id="tr-name">—</strong> · <span id="tr-time">0:00</span> / <span id="tr-total">0:00</span></div>' +
    '</div>' +
    '<div class="tr-hint">' + tx.hint + '</div>' +
  '</div>';
}
